// extracted by mini-css-extract-plugin
export default {"root":"number-input_root__XQqO7","placeHolderShimmer":"number-input_placeHolderShimmer__lqcjC"};